var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53 15.04c-.83-.47-1.28-1.4-1.28-2.62V2.44c0-.41.34-.75.75-.75s.75.34.75.75v9.98c0 .65.19 1.13.52 1.31.35.2.89.1 1.48-.25l1.32-.79c.54-.32 1.31-.32 1.85 0l1.32.79c.6.36 1.14.45 1.48.25.33-.19.52-.67.52-1.31V2.44c0-.41.34-.75.75-.75s.75.34.75.75v9.98c0 1.22-.45 2.15-1.28 2.62-.83.47-1.92.37-2.99-.27l-1.32-.79c-.06-.04-.25-.04-.31 0l-1.32.79c-.62.37-1.26.56-1.84.56-.42 0-.81-.1-1.15-.29z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53 15.04c-.83-.47-1.28-1.4-1.28-2.62V2.44c0-.41.34-.75.75-.75s.75.34.75.75v9.98c0 .65.19 1.13.52 1.31.35.2.89.1 1.48-.25l1.32-.79c.54-.32 1.31-.32 1.85 0l1.32.79c.6.36 1.14.45 1.48.25.33-.19.52-.67.52-1.31V2.44c0-.41.34-.75.75-.75s.75.34.75.75v9.98c0 1.22-.45 2.15-1.28 2.62-.83.47-1.92.37-2.99-.27l-1.32-.79c-.06-.04-.25-.04-.31 0l-1.32.79c-.62.37-1.26.56-1.84.56-.42 0-.81-.1-1.15-.29z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBookmark);
export default __webpack_public_path__ + "static/media/vuesax-outline-bookmark.4e185f02621f7400a987e2dd81c8256b.svg";
export { ForwardRef as ReactComponent };